import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from "@angular/router";

import { RouteRedirector } from "../shared/providers/routeRedirector";
import { AccountDataStore } from "../shared/providers/accountData/accountDataStore";
import { UserService } from '../shared/providers/userService';
import { RouteNames, AuthGuard } from "../shared/providers";
import { AuthorizationGroup } from "../shared/models";
import { GlobalDataStore } from "../shared/providers/globalData";

@Injectable()
export class DealerAuthGuard extends AuthGuard implements CanActivate {

  constructor(public routerRedirector: RouteRedirector,
    public accountStore: AccountDataStore,
    public userService: UserService,
    public globalDataStore: GlobalDataStore
  ) {
    super(routerRedirector, accountStore, userService);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    let canActivate = super.canActivate(route, state);

    if (canActivate) {
      let user = this.accountStore.getUser();
      let cusAccessDCP = user.propertyMap.get('cusAccessDCP');
      return cusAccessDCP;
    }
    return false;
  }
}